import InfoIcon from '@mui/icons-material/Info';
import { IconButton, IconButtonProps } from '@mui/material';

function InfoButton(props: IconButtonProps) {
  return (
    <IconButton {...props}>
      <InfoIcon />
    </IconButton>
  );
}
export default InfoButton;
